import { getGeo } from '@mc/geo'

// list of GDPR countries with "gdpr_config: 1" taken from lib/tasks/country_options.rake
const gdprCountries = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MF',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
]

export const VISIBLE_UNCHECKED = 'visible_unchecked'
export const NOT_VISIBLE_CHECKED = 'not_visible_checked'
export const VISIBLE_CHECKED = 'visible_checked'

export default function getCheckboxState() {
  const userGeo = getGeo()
  if (gdprCountries.includes(userGeo)) {
    return VISIBLE_UNCHECKED
  } else if (userGeo === 'US') {
    return NOT_VISIBLE_CHECKED
  }
  return VISIBLE_CHECKED
}

export const isGDPRCountry = (country: string) =>
  gdprCountries.includes(country)
